import { render, staticRenderFns } from "./FormResearch4.vue?vue&type=template&id=608e2100&scoped=true"
import script from "./FormResearch4.vue?vue&type=script&lang=js"
export * from "./FormResearch4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608e2100",
  null
  
)

export default component.exports